<template>
  <div>
    <div
      class="d-flex position-relative roadblock roadblock-bg"
    >
      <div class="align-items-center d-flex flex-column roadblock-content">
        <AppSumoLogo class="icon mb-3" />
        <span class="d-block mb-3 text-flat-shadow">$1 Million</span>
        <span class="d-block mb-2 roadblock-subtitle font-weight-bold">Black Friday Fund</span>

        <p class="text-center mb-3 roadblock-description font-weight-bold">
          Win up to $10K listing a digital product before November 17th. <br>
          Then make bank selling during our BIGGEST event of the year!
        </p>

        <div class="roadblock-button-container">
          <a
            :href="`/accounts/signup/?next=/partners/apply/&${utmParams}`"
            class="btn roadblock-btn mb-2 mb-md-0 mr-0 mr-md-2"
            rel="noopener"
          >
            Sell on Black Friday
          </a>
          <a
            href="https://sell.appsumo.com/black-friday-fund"
            class="btn btn-white"
            rel="noopener"
          >
            View details
          </a>
        </div>
      </div>

      <img
        :src="BannerLeft"
        class="d-lg-block d-none roadblock-banner-left"
        alt="Left image"
      >
      <img
        :src="BannerRight"
        class="d-lg-block d-none roadblock-banner-right"
        alt="Right image"
      >
    </div>
  </div>
</template>

<script>
import BannerLeft from '~/static/roadblocks/banner-left.svg';
import BannerRight from '~/static/roadblocks/banner-right.svg';
import AppSumoLogo from '~/static/roadblocks/appsumo-logo.svg?inline';

export default {
  components: { AppSumoLogo },

  data() {
    return {
      BannerLeft,
      BannerRight,
      utmParams: '',
    };
  },

  mounted() {
    this.utmParams = new URLSearchParams({
      utm_source: this.$cookies.get('utm_source') || 'as-site',
      utm_campaign: this.$cookies.get('utm_campaign') || 'bf-fund-submit',
      utm_medium: this.$cookies.get('utm_medium') || 'bf-fund',
    }).toString();
  },
};
</script>

<style lang="scss" scoped>
// TODO: Refactor roadblock styles, there are several styles that are being
// added to multiple components that do the same, we should create a scss file
// to contain generic styles for roadblocks.
@import '~/styles/utils/breakpoints';

.roadblock {
  align-items: center;
  background-color: #fff5db;
  margin-bottom: 60px;
  margin-left: -30px;
  margin-right: -30px;
  padding: 30px;
  justify-content: center;
  min-height: 500px;
}

.roadblock-bg {
  background-image: url(~/static/roadblocks/rays.svg);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.roadblock-subtitle {
  font-size: 35px;
  font-family: Barlow, sans-serif;
}

.roadblock-content {
  max-width: 650px;
}

.roadblock-description {
  font-size: 16px;
}

.roadblock-button-container {
  background-color: #fff;
  border-radius: 35px;
  padding: 1rem;
}

.btn {
  border-radius: 25px;
  padding: 0.3rem 1rem;
  width: 100%;
}

// Overriding btn color to avoid issues with our layouts colors
.roadblock-btn {
  color: #212529;
  background-color: #ffbc00;
  border-color: #ffbc00;

  &:hover,
  &:focus {
    color: #212529;
    background-color: #d9a000;
    border-color: #cc9600;
  }
}

.btn-white {
  background-color: #fff;
  border: 2px solid #000;

  &:focus,
  &:hover {
    background-color: #f7f7f7;
  }
}

.roadblock-banner-left {
  left: 0;
  position: absolute;
  top: 0;
  height: 100%;
}

.roadblock-banner-right {
  right: 0;
  position: absolute;
  top: 0;
  height: 100%;
}

.text-flat-shadow {
  border: 2px solid #000;
  background-color: #fff;
  box-shadow: 10px 10px 1px 0 #000;
  font-family: Barlow, sans-serif;
  font-size: 50px;
  font-style: italic;
  font-weight: 700;
  line-height: 1;
  padding: 0.5rem 1rem;
  position: relative;
  text-transform: uppercase;
}

@include media-breakpoint-up(md) {
  .roadblock {
    padding: 32px 64px;
  }

  .btn {
    width: auto;
  }

  .text-flat-shadow {
    font-size: 60px;
    padding: 0.5rem 4rem;
  }
}
</style>
